import { render } from "./Proposals.vue?vue&type=template&id=51c2b24b&scoped=true"
import script from "./Proposals.vue?vue&type=script&lang=js"
export * from "./Proposals.vue?vue&type=script&lang=js"

import "./Proposals.vue?vue&type=style&index=0&id=51c2b24b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c2b24b"]])

export default __exports__